import React from 'react';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import moneyHelper from '../Helpers/moneyHelper';

export default class OfficeCostGroupLinkItem {
  // currencyCode is the office's billing currency, supplied by the caller: the link rows themselves
  // carry no currency, the costs are simply stored in whatever the office bills in.
  constructor(item, currencyCode) {
    this.CurrencyCode = currencyCode ?? '';
    if (item === undefined) {
      this.OfficeCostGroupLinkId = '';
      this.OfficeId = '';
      this.CostGroupId = '';
      this.CalculateWeeklyAverage = false;
      this.EmployeeHourlyCost = 0;
      this.OutSourcedHourlyCost = 0;
      this.CostGroupLabel = '';
    } else {
      this.OfficeCostGroupLinkId = item.officeCostGroupLinkId;
      this.OfficeId = item.officeId;
      this.CostGroupId = item.costGroupId;
      this.CostGroupLabel = item.costGroupLabel;
      this.CalculateWeeklyAverage = item.calculateWeeklyAverage;
      this.EmployeeHourlyCost = item.employeeHourlyCost;
      this.OutSourcedHourlyCost = item.outSourcedHourlyCost;
    }
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Cost Group Label', orderById: '', data: (item) => item.CostGroupLabel },
      {
        label: 'Employee Hourly Cost',
        orderById: '',
        data: (item) => moneyHelper.toMoneyFormat(item.EmployeeHourlyCost, item.CurrencyCode),
      },
      {
        label: 'OutSourced Hourly Cost',
        orderById: '',
        data: (item) => moneyHelper.toMoneyFormat(item.OutSourcedHourlyCost, item.CurrencyCode),
      },
      {
        label: 'Calculate Weekly Average',
        orderById: '',
        data: (item) => JsxHelper.YesNo(item.CalculateWeeklyAverage),
      },
      {
        label: ' ',
        orderById: '',
        data: OfficeCostGroupLinkItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static clickOnEdit = () => {};

  static getActionCellContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            onClick: () => OfficeCostGroupLinkItem.clickOnEdit(item),
            iconName: 'fa-solid fa-edit',
            roleKey: 'home_offices_edit',
          },
        ]}
      />
    );
  }
}
